// Generated by Melange

import MediaHeaderModuleCss from "./mediaHeader.module.css";
import * as Caml_option from "melange.js/caml_option.jsx";
import * as Shared__CoverArt from "./coverArt.jsx";
import * as JsxRuntime from "react/jsx-runtime";

const css = MediaHeaderModuleCss;

const media_header_cover_art_sizes = "(max-width: 639px) 100vw, (max-width: 767px) 192px, (max-width: 1023px) 234.667px, (max-width: 1279px) 236px, (max-width: 1535px) 236.8px, 237.3333px";

function MediaHeader(Props) {
  let children = Props.children;
  let coverArt = Props.coverArt;
  let links = Props.links;
  let tmp = {
    sizes: media_header_cover_art_sizes
  };
  if (coverArt !== undefined) {
    tmp.coverArt = Caml_option.valFromOption(coverArt);
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(Shared__CoverArt.make, tmp),
          JsxRuntime.jsx("div", {
            children: links,
            className: css.links
          })
        ],
        className: css.leftCol
      }),
      JsxRuntime.jsx("div", {
        children: children,
        className: css.rightCol
      })
    ],
    className: css.root
  });
}

const make = MediaHeader;

export {
  media_header_cover_art_sizes,
  make,
}
/* css Not a pure module */
